import { z } from "zod";

const CreatorWarningFindingSchema = z.object({
  key: z.string().trim().min(1).max(100),
  title: z.string().trim().min(1).max(160),
  status: z.string().trim().min(1).max(40),
  score: z.number().finite(),
  confidence: z.string().trim().max(40).optional(),
  reasons: z.array(z.string().trim().min(1).max(500)).max(20),
  counterEvidence: z.array(z.string().trim().min(1).max(500)).max(20),
  limitations: z.array(z.string().trim().min(1).max(500)).max(20),
  evidenceEventIds: z.array(z.string().trim().min(1).max(200)).max(100),
  detectorVersion: z.string().trim().max(100).nullable().optional(),
});

export const IssueCreatorWarningSchema = z.object({
  creatorId: z.string().regex(/^[a-f0-9]{24}$/i, "Invalid creator ID"),
  issuedBy: z.string().trim().email().max(320),
  evidenceSnapshot: z.object({
    runId: z.string().trim().max(200).nullable().optional(),
    analysisVersion: z.string().trim().max(100).nullable().optional(),
    windowType: z.string().trim().min(1).max(40),
    windowStart: z.string().trim().min(1).max(80).nullable().optional(),
    windowEnd: z.string().trim().min(1).max(80).nullable().optional(),
    assessmentStatus: z.string().trim().min(1).max(40),
    assessmentConfidence: z.string().trim().max(40).nullable().optional(),
    assessmentReasons: z.array(z.string().trim().min(1).max(500)).max(20),
    limitations: z.array(z.string().trim().min(1).max(500)).max(20),
    findings: z.array(CreatorWarningFindingSchema).min(1).max(10),
  }),
});

export type IssueCreatorWarningDto = z.infer<typeof IssueCreatorWarningSchema>;
